export default "__VITE_ASSET__DPAfiBbP__"